import { useAppSelector } from 'hooks'
import { CallWidget } from './components'
import { useState } from 'react'

export const CallWidgets = () => {
    const { activeAvailableCalls } = useAppSelector((state) => state.callCenter)
    const calls = Object.values(activeAvailableCalls)
    const [listeningCallId, setListeningCallId] = useState<string | null>(null)

    if (!calls.length) {
        return null
    }

    return (
        <>
            {calls.map((call, index) => (
                <CallWidget
                    key={call.callId}
                    callId={call.callId}
                    index={index}
                    initiatedBy={call.initiatedBy}
                    listeningCallId={listeningCallId}
                    setListeningCallId={setListeningCallId}
                />
            ))}
        </>
    )
}
